import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

export function useCountdown(): [number, Dispatch<SetStateAction<number>>] {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [countdown]);

  return [countdown, setCountdown];
}
